import Bowser from 'bowser';
import publicIp from 'public-ip';

const nav = window.navigator;
export const browserInformation = async () => {
  let browserInformation = Bowser.parse(nav.userAgent);
  browserInformation.userAgent = nav.userAgent;
  try {
    browserInformation.ipv4 = await publicIp.v4({
      onlyHttps: true,
      fallbackUrls: [
        'https://ipecho.net/plain',
        'https://l2.io/ip',
        'https://api.kwelo.com/v1/network/ip-address/my',
        'https://myexternalip.com/raw',
      ],
    });
  } catch (e) {
    console.error(e);
    browserInformation.ipv4 = null;
  }
  return browserInformation;
};
